module.exports = __webpack_public_path__ + "img/mail-blue.8bd7abb6.svg";